<section class="section-1">
	<h1 class="numbered-title">
		<span aria-hidden="true"
			><i class="fa fa-exclamation-triangle fa-2x"> </i
		></span>
		HTTP: 404 Error
	</h1>
	<br />
</section>

<section class="section-2">
	<h2>Page not found</h2>
</section>

<section class="section-3">
	<form>
		<div>
			<textarea
				disabled
				[addAttribute]="'highlight'"
				#errorTextDisplay
			></textarea>
		</div>
	</form>
</section>
